var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5856 1.69931C20.8749 1.22902 20.7281 0.613302 20.2578 0.324051C19.7875 0.0348008 19.1718 0.181557 18.8826 0.651839L20.5856 1.69931ZM7.35111 21.3087L6.59947 21.9678C6.80875 22.2065 7.11893 22.3315 7.43522 22.3048C7.75152 22.2781 8.03633 22.1028 8.20263 21.8324L7.35111 21.3087ZM2.23816 13.9617C1.87414 13.5466 1.24253 13.5051 0.827409 13.8692C0.41229 14.2332 0.370864 14.8648 0.73488 15.2799L2.23816 13.9617ZM18.8826 0.651839L6.49958 20.7849L8.20263 21.8324L20.5856 1.69931L18.8826 0.651839ZM8.10275 20.6496L2.23816 13.9617L0.73488 15.2799L6.59947 21.9678L8.10275 20.6496Z",
    fill: "#C5EB7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.50d54e827fc8ccd2c7ca97617398eb1a.svg";
export { ForwardRef as ReactComponent };